import { CustomDataAdaptor } from '@syncfusion/ej2-data';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { fakeHttpRequest } from '../fakeHttpRequest';
import { IDynamicAutocompleteItem } from './dynamic-autocomplete-item';

export class DynamicAutocompleteCustomAdaptor extends CustomDataAdaptor {
  private searchSubject = new Subject<{ searchText: string; args: any }>();

  constructor(private getDataFunction: (searchText: string) => Observable<string[] | IDynamicAutocompleteItem[]>) {
    super();
    this.options.getData = this.getData.bind(this);

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged((prev, curr) => prev.searchText === curr.searchText),
      switchMap(({ searchText, args }) =>
        this.getDataFunction(searchText).pipe(
          switchMap(result => {
            args.onSuccess(result, { httpRequest: new fakeHttpRequest() });
            return [];
          }),
        )
      ),
    ).subscribe({
      error: () => {},
    });
  }

  private getData(args: any) {
    const data = JSON.parse(args.data);
    if (this.getDataFunction == null) {
      args.onFailure('getDataFunction is null');
      return;
    }

    const searchText = data.where ? data.where[0].value : null;
    this.searchSubject.next({ searchText, args });
  }
}
